import { render, staticRenderFns } from "./WithActionDisplay.vue?vue&type=template&id=06849ff1&scoped=true"
var script = {}
import style0 from "./WithActionDisplay.vue?vue&type=style&index=0&id=06849ff1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06849ff1",
  null
  
)

export default component.exports